module.exports = __webpack_public_path__ + "img/calendar-blue.f4aa8d1b.svg";